export const getInvoiceInputs = () => {
    return [
        {
            _key: "invoice_date",
            _name: "Invoice Date",
            _value: "",
            _type: "date",
            _placeholder: "Invoice Date",
            _helperText: "Please enter Invoice Date",
            _mandatory: true,
            _errorMsg: "",
            _options: {},
            _gridSize: 6,
        },
    ];
};
